import { render } from "./App.vue?vue&type=template&id=43ddef4e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=43ddef4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43ddef4e"

export default script